import { ApplicationConfigurationDto } from '@abp/ng.core';

// Minimal safe fallback configuration so ABP dependent components don't crash when API is unreachable.
// Only populate required properties with benign defaults matching expected types.
export const FALLBACK_APP_CONFIG: ApplicationConfigurationDto = {
	localization: {
		values: {},
		languages: [
			{
				cultureName: 'en',
				uiCultureName: 'en',
				displayName: 'English'
			} as any
		],
		languagesMap: {},
		languageFilesMap: {},
		resources: {
			// Provide at least one resource expected by ABP UI so localization lookups do not throw.
			AbpUi: {
				texts: {},
				baseResources: []
			} as any
		},
		currentCulture: {
			cultureName: 'en',
			displayName: 'English',
			isRightToLeft: false,
			dateTimeFormat: {
				dateSeparator: '/',
				shortDatePattern: 'M/d/yyyy',
				fullDateTimePattern: 'dddd, MMMM d, yyyy h:mm:ss tt',
				longTimePattern: 'h:mm:ss tt',
				shortTimePattern: 'h:mm tt'
			}
		},
		defaultResourceName: 'AbpUi'
	},
	auth: {
		grantedPolicies: {},
		policies: {},
		requireConfirmedEmail: false
	} as any, // cast for fields possibly differing by ABP version
	features: { values: {} },
	currentUser: {
		id: undefined,
		userName: 'offline',
		name: undefined,
		surName: undefined,
		email: undefined,
		emailVerified: false,
		phoneNumber: undefined,
		phoneNumberVerified: false,
		tenantId: undefined,
		isAuthenticated: false,
		roles: []
	},
	multiTenancy: { isEnabled: false },
	currentTenant: { id: undefined, name: undefined, isAvailable: false },
	timing: { timeZone: { iana: { timeZoneName: 'UTC' }, windows: { timeZoneId: 'UTC' } } },
	clock: { kind: 'unspecified' },
	objectExtensions: { modules: {}, enums: {} },
	setting: { values: {} } as any,
	globalFeatures: { enabledFeatures: [] } as any,
	extraProperties: {}
};
